module.exports = __webpack_public_path__ + "static/media/tenderbanner@3x.8966c2a1.png";